module.exports = __webpack_public_path__ + "static/media/illu_help_map.216c025b.png";